import type { BlockComponentProps } from "./shared"

export function AuthorBioBlock({ content, resolved }: BlockComponentProps) {
  const primaryColor = "var(--nos-color-primary, #3b82f6)"
  const abSectionClass = resolved.hasOverrides
    ? `px-4 @sm:px-6 @md:px-8 ${resolved.paddingClass || "py-6"} ${resolved.cornerClass} ${resolved.alignClass} max-w-2xl mx-auto`.trim()
    : "px-4 py-6 @sm:px-6 @md:px-8 max-w-2xl mx-auto"
  const abHeading = (content?.heading as string) ?? ""
  // Support new multi-author format; fall back to legacy single-author fields
  const rawAuthors = content?.authors as Array<{ name?: string; role?: string; bio?: string; image_url?: string; social_links?: Array<{ label: string; url: string }> }> | undefined
  const authors = rawAuthors && rawAuthors.length > 0
    ? rawAuthors
    : [{
        name: (content?.name as string) ?? "",
        role: (content?.role as string) ?? "",
        bio: (content?.bio as string) ?? "",
        image_url: (content?.image_url as string) ?? "",
        social_links: (content?.social_links as Array<{ label: string; url: string }>) ?? [],
      }]
  return (
    <section className={abSectionClass} style={resolved.sectionStyle}>
      {abHeading && (
        <h2 className="text-lg font-semibold mb-4">{abHeading}</h2>
      )}
      <div className="flex flex-col gap-4">
        {authors.map((author, i) => {
          const links = author.social_links ?? []
          return (
            <div key={i} className="flex gap-4 items-start rounded-lg border p-4">
              {author.image_url && (
                <img
                  src={author.image_url}
                  alt={author.name || "Author"}
                  className="h-20 w-20 rounded-full object-cover flex-shrink-0"
                />
              )}
              <div>
                {author.name && <p className="font-semibold">{author.name}</p>}
                {author.role && <p className="text-sm" style={{ color: primaryColor }}>{author.role}</p>}
                {author.bio && <p className="text-sm text-muted-foreground mt-2">{author.bio}</p>}
                {links.length > 0 && (
                  <div className="mt-2 flex gap-2 flex-wrap">
                    {links.map((link, li) => (
                      <a
                        key={li}
                        href={link.url.startsWith("http") ? link.url : `https://${link.url}`}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="text-sm font-medium"
                        style={{ color: primaryColor }}
                      >
                        {link.label}
                      </a>
                    ))}
                  </div>
                )}
              </div>
            </div>
          )
        })}
      </div>
    </section>
  )
}
